module.exports = __webpack_public_path__ + "static/10-75638e2423dd5f5735b9b7b9b35cf016.jpg";